import _ from 'underscore';

export const Roles = {
  Admin: 'Admin',
  Recruiter: 'Recruiter'
};

/**
 * The application model encapsulates the token and provides methods to access fields from the token
 */
export default class ApplicationModel {
  constructor({ token = null, selectedAccount = 0 }) {
    this.token = token;
    this.selectedAccount = selectedAccount;
  }

  getSelectedAccount() {
    const user = this.getUser();
    if (user === null) {
      return null;
    }

    const { accounts } = user;
    if (this.selectedAccount < accounts.length && this.selectedAccount >= 0) {
      return accounts[ this.selectedAccount ];
    } else {
      return null;
    }
  }

  isLoggedIn() {
    return !!this.token;
  }

  getName() {
    const user = this.getUser();
    if (user === null) {
      return null;
    }

    return user.name;
  }

  getToken() {
    if (!this.isLoggedIn()) {
      return null;
    }
    return this.token.accessToken;
  }

  isAdvanced() {
    const acct = this.getSelectedAccount();
    if (acct === null) {
      return false;
    }

    return acct.advanced;
  }

  getAccountId() {
    const acct = this.getSelectedAccount();
    if (acct === null) {
      return null;
    }

    return acct.accountId;
  }

  getUserId() {
    const user = this.getUser();
    if (user === null) {
      return null;
    }

    return user.id;
  }

  getUser() {
    if (!this.isLoggedIn()) {
      return null;
    }

    return this.token.userDetails;
  }

  isSuperAdmin() {
    const user = this.getUser();
    if (user === null) {
      return null;
    }

    return user.superAdmin;
  }

  getUserAccess() {
    if (this.isAdvanced()) {
      if (this.hasFastConnect()) {
        return 'Team FastConnect';
      }
      return 'Team';
    } else {
      return 'Standard';
    }
  }

  hasFastConnect() {
    return this.getSelectedAccount() && _.contains(this.getSelectedAccount().features, 'FastConnect');
  }

  hasAccount(requiredAccountId) {
    return this.hasAccountRole(requiredAccountId);
  }

  hasAccountRole(requiredAccountId, role = null) {
    if (!this.isLoggedIn() || !requiredAccountId) {
      return false;
    }

    if (this.isSuperAdmin()) {
      return true;
    }

    return _.any(this.getUser().accounts, ({ accountId, roles }) => {
      return accountId === requiredAccountId && (role === null || _.contains(roles, role));
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/common/ApplicationModel.js